"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiProfile16 = {
    paths: [
        {
            path: 'M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,2 C4.6862915,2 2,4.6862915 2,8 C2,9.77706308 2.77255645,11.3736859 4.0001315,12.4723307 L4,11.637486 C4,10.5329165 4.8954305,9.63748605 6,9.63748605 L10,9.63748605 C11.1045695,9.63748605 12,10.5329165 12,11.637486 L12.0008689,12.4714352 C13.2278632,11.3728184 14,9.77658031 14,8 C14,4.6862915 11.3137085,2 8,2 Z M8,4.59371512 C9.26236514,4.59371512 10.2857143,5.59734764 10.2857143,6.83539109 C10.2857143,8.07343454 9.26236514,9.07706706 8,9.07706706 C6.73763486,9.07706706 5.71428571,8.07343454 5.71428571,6.83539109 C5.71428571,5.59734764 6.73763486,4.59371512 8,4.59371512 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'User Profile',
    width: 16,
    height: 16,
};
var muiProfile24 = {
    paths: [
        {
            path: 'M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,14.1531319 3.75609185,16.1296691 5.0172509,17.678587 C5.17770225,16.172584 6.45191529,15 8,15 L16,15 C17.5480847,15 18.8222977,16.172584 18.9829256,17.6780386 C20.2439081,16.1296691 21,14.1531319 21,12 C21,7.02943725 16.9705627,3 12,3 Z M12,6 C14.209139,6 16,7.790861 16,10 C16,12.209139 14.209139,14 12,14 C9.790861,14 8,12.209139 8,10 C8,7.790861 9.790861,6 12,6 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'User Profile',
    width: 24,
    height: 24,
};
var muiProfile = {
    base: muiProfile16,
    smIcon: muiProfile16,
    lgIcon: muiProfile24,
};
exports.muiProfile = muiProfile;
//# sourceMappingURL=profile.js.map